<template>
  <div class="scan-sign-container">
    <!-- 标题栏 -->
    <div class="header">
      <div class="input-wrapper">
        <div class="input-group">
          <el-icon class="camera-icon" @click="getSnNumber">
            <Camera />
          </el-icon>
          <input
              ref="input"
              class="search-input"
              v-model="trackNumber"
              autofocus
              :placeholder="$t('mobile.returnList.scan')"
              @keyup.enter="onSubmit"
          />
          <el-icon v-if="!trackNumber" class="scan-icon" @click="sacnImage">
            <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
              <path d="M128 128h128v128H128z"/>
              <path d="M768 128h128v128H768z"/>
              <path d="M128 768h128v128H128z"/>
              <path d="M768 768h128v128H768z"/>
              <path d="M320 128h64v64h-64z"/>
              <path d="M640 128h64v64h-64z"/>
              <path d="M320 832h64v64h-64z"/>
              <path d="M640 832h64v64h-64z"/>
              <path d="M128 320h64v64H128z"/>
              <path d="M128 640h64v64H128z"/>
              <path d="M832 320h64v64h-64z"/>
              <path d="M832 640h64v64h-64z"/>
              <path d="M384 384h256v256H384z"/>
              <path d="M416 416h192v192H416z"/>
              <path d="M448 448h128v128H448z"/>
            </svg>
          </el-icon>
          <el-icon class="camera-icon" @click="clear" v-else ><CircleCloseFilled /></el-icon>
        </div>
      </div>
    </div>
    <PullRefresh
        @refresh="handleRefresh"
        @loadmore="handleLoadMore"
        ref="pullRefresh"
    >
      <!-- 签收区块 -->
      <div class="sign-card" v-for="(item, index) in returnList" :key="index">
        <div class="flex flex-row-between flex-item-center">
          <div class="group-title">{{$t("mobile.returnList.info")}}:</div>
          <el-button
              type="primary"
              size="small"
              @click="inStore(item)"
              class="action-btn"
          >
            <el-icon><Check /></el-icon>
            {{ $t( "mobile.returnList.resion"+item.isSend ) }}
          </el-button>
        </div>

        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.sale") }}</span>
          <span >{{item.salesRecordNumber}}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.trackNumber") }}</span>
          <span >{{item.receiveNumber}}</span>
        </div>
        <div class="form-row">
          <span class="label">SKU:</span>
          <span >{{item.receiveMaterSku}}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.product")}}:</span>
          <span class="ellipsis">{{item.receiveMaterName}}</span><span>*{{item.quantity}}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.remark")}}:</span>
          <span >{{item.remark || $t("mobile.returnList.remarks") }}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.inTime")}}:</span>
          <span >{{item.inTime || $t("mobile.returnList.inTimes") }}</span>
        </div>

      </div>
    </PullRefresh>
    <mobileSel ref="mobileSel" @confirm="confirmSelect" ></mobileSel>
    <input hidden type="file" @change="handleFileChange" ref="fileInput" />
    <audio ref="successAudio" src="/static/success.mp3" preload="auto"></audio>
    <audio ref="failAudio" src="/static/fail.mp3" preload="auto"></audio>
  </div>
</template>

<script>
import {ElButton, ElIcon, ElMessage} from "element-plus";
import PullRefresh from '@/components/PullRefresh.vue'
import { getReturnList} from "@/utils/api"
import http, {uploadUrl} from "@/utils/requset";
import mobileSel from "@/components/mobileSel.vue";
export default {
  name: 'returnList',
  components:{
    mobileSel,
    ElButton,PullRefresh,ElIcon
  },
  data() {
    return {
      trackNumber:"",
      page: 1,
      pageSize: 10,
      hasMore: true,
      returnList: [

      ]
    }
  },
  beforeMount() {
    if(this.$route.query?.trackNumber){
      this.trackNumber =  this.$route.query.trackNumber
    }
  },
  mounted() {
    // 如果是自动搜索模式，延迟执行查询
    this.$nextTick(() => {
      setTimeout(() => {
        // this.loadData();
      }, 500); // 延迟500ms确保页面完全加载
    });
    this.$refs.input.focus()
  },
  methods: {
    // 播放成功音效
    playSuccessAudio() {
      const audio = new Audio('/static/success.mp3');
      audio.play();
    },
    // 播放失败音效
    playFailAudio() {
      const audio = new Audio('/static/fail.mp3');
      audio.play();
    },
    open(data){
      if(data.length<1){
        ElMessage.warning(this.$t("mobile.returnList.prompt") )
      }else if(data.length==1){
        this.trackNumber=data[0].data
        // 自动触发查询
        this.$nextTick(() => {
          setTimeout(() => {
            this.onSubmit();
          }, 300);
        });
      }else{
        let dataList = data.map((item)=>{
          return {
            value: item.data,
            label: item.data
          }
        })
        this.$refs.mobileSel.open(dataList)
      }
    },
    confirmSelect(data){
      this.trackNumber=data
      // 自动触发查询
      this.$nextTick(() => {
        setTimeout(() => {
          this.onSubmit();
        }, 300);
      });
    },
    getSnNumber(){
      this.$refs.fileInput.click()
    },
    handleFileChange(event){
      const file = event.target.files[0]; // 获取第一个文件
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error(this.$t("mobile.returnList.uploadPrompt"));
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error(this.$t("mobile.returnList.uploadSize"))
        return false
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('isTr',true);
      http.post(uploadUrl,formData, {}).then(res=>{
        event.target.value = ''
        this.open(res.Data)
      }).catch(err=>{
        console.log(err)
      })
    },
    clear(){
      this.page = 1
      this.trackNumber = ""
      // 清空后自动聚焦输入框
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    onSubmit(){
      if(!this.trackNumber) return
      this.page = 1
      getReturnList({"trackNumber":this.trackNumber,"PageNumber":this.page,"PageSize":this.pageSize}).then(res=>{
        this.returnList = res.Data
        if( this.returnList.length <=0 ){
          // 播放失败音效
          this.playFailAudio()
          setTimeout(() => {
            this.$router.push({
              path:"/tempInStore",
              query:{trackNumber:this.trackNumber},
            });
          }, 200);
        } else {
          // 播放成功音效
          this.playSuccessAudio()
        }
        if(this.returnList.length >= res.Total ){
          this.hasMore = false
        } else {
          this.hasMore = true
        }
        // 重置PullRefresh组件状态
        this.$nextTick(() => {
          if(this.$refs.pullRefresh) {
            this.$refs.pullRefresh.refresh()
          }
        })
      }).catch(err=>{
        console.log(err)
        // 请求失败也播放失败音效
        this.playFailAudio()
      })
    },
    sacnImage(){
      this.$router.push({
        path: '/sacnImage',
      });
    },
    loadData() {
      // 模拟API请求
      getReturnList({"trackNumber":this.trackNumber,"PageNumber":this.page,"PageSize":this.pageSize}).then(res=>{
        this.returnList.push(...res.Data)
        if(this.returnList.length >= res.Total ){
          this.hasMore = false
        } else {
          this.hasMore = true
        }
        // 确保PullRefresh组件更新
        this.$nextTick(() => {
          if(this.$refs.pullRefresh) {
            this.$refs.pullRefresh.refresh()
          }
        })
      }).catch(err=>{
        console.log(err)
      })
    },
    inStore(data){
      this.$router.push({
        path: '/inStore',
        query:{
          receiveSaleType:data.receiveSaleType,
          recordId:data.recordId,
          receiveSaleNumber:data.receiveSaleNumber
        }
      });
    },
    handleRefresh(done) {
      this.page = 1
      this.hasMore = true
      this.returnList = []
      this.loadData()
      done()
    },
    handleLoadMore(done) {
      if (!this.hasMore) {
        done()
        return
      }
      this.page++
      this.loadData()
      done()
    }
  }
}
</script>

<style scoped>
.scan-sign-container {
  padding: 12px;
  max-width: 100%;
  box-sizing: border-box;
}

.input-wrapper {
  flex: 1;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.input-group:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.input-group:focus-within {
  box-shadow: 0 0 0 2px #409eff, 0 4px 16px rgba(64, 158, 255, 0.2);
}

.scan-icon, .camera-icon {
  padding: 12px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 18px;
}

.scan-icon:hover, .camera-icon:hover {
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}

.scan-icon {
  color: #67c23a;
  font-size: 20px;
}

.scan-icon:hover {
  color: #85ce61;
  background-color: rgba(103, 194, 58, 0.1);
  transform: scale(1.1);
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 16px;
  font-size: 16px;
  background: transparent;
  color: #303133;
}

.search-input::placeholder {
  color: #c0c4cc;
  font-size: 14px;
}

.search-button-wrapper {
  flex-shrink: 0;
}

.search-btn {
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.4);
}

.header {
  margin-bottom: 16px;
  text-align: center;
}

.title {
  font-size: 20px;
  color: #409EFF;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 12px;
  color: #909399;
}

.sign-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #00000014;
}


.group-title {
  text-align: left;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  unicode-bidi: isolate;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.label {
  width: 80px;
  font-size: 14px;
  color: #606266;
  flex-shrink: 0;
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .form-row {
    align-items: flex-start;
  }
  .label {
    margin-bottom: 4px;
  }

}
.ellipsis {
  white-space: nowrap;  /* 强制文本不换行 */
  overflow: hidden;     /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出时显示省略号 */
  width: 60%;         /* 必须设置宽度 */
  text-align: left;
}
</style>